<div class="widget">
  <div class="widget-content" [style.background-image]="'url(' + settings.imageLocation + ')'">
    <span class="title" [style.color]="settings.imageLocation ? '#FFFFFF' : 'black'">{{ settings.title }}</span>
    <small [style.color]="settings.imageLocation ? '#FFFFFF' : 'black'">{{ settings.description }}</small>
    <a href="{{ settings.buttonUrl }}" target="_blank" *ngIf="settings.buttonText && settings.buttonUrl && settings.buttonType === 'hyperlink'" [style.color]="settings.imageLocation ? '#FFFFFF' : 'black'">         
      {{ settings.buttonText }}
    </a>
    <a (click)="openVideo()" *ngIf="settings.buttonText && settings.buttonUrl && settings.buttonType === 'video'" [style.color]="settings.imageLocation ? '#FFFFFF' : 'black'">         
      {{ settings.buttonText }}
    </a>
  </div>
</div>